module.exports = __webpack_public_path__ + "static/media/team11.02340bf6.png";